import React, { Component } from 'react'
import {connect} from 'react-redux'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import DateFromDateTo from './DateFromDateTo'
import dateFormat from "dateformat"
import { cardStatement, getSettlementChargebacks, clearSettlementChargebacks } from '../../../action/cardDetails'
import TransactionTable from './TransactionTable'
import { withTheme } from '@material-ui/core/styles'
import download from 'downloadjs'
import b64toBlob from '../../../util/b64toBlob'
import ReverseTransactionForm from './ReverseTransactionForm'
import { resetReverseTransaction } from '../../../action/transaction'
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import SettlementChargebacksResults from "./SettlementChargebacksResults"
import moment from 'moment'
import { PDFDownloadLink, pdf } from '@react-pdf/renderer'
import TransactionTablePrintDetails from './TransactionTablePrintDetails'
import PropTypes from 'prop-types'

export const today = new Date()
export const threeMonthAgo =new Date( today.getFullYear(),(today.getMonth() -3), today.getDate())

class CardTransactions extends Component{

  constructor(props){
    super(props)
    this.state = {
      startDate: dateFormat(new Date(threeMonthAgo), "yyyy-mm-dd"),
      endDate: dateFormat(new Date(today), "yyyy-mm-dd"),
      reverseDialogOpen: false,
      transactionToReverse: null,
      isValidDate: true,
      validationErrorMsg: ''
    }
  }

  componentWillReceiveProps(nextProps){
    this.state.isValidDate && nextProps.cardDetailsResponse !== this.props.cardDetailsResponse&&
      this.props.cardStatement(this.props.token, nextProps.cardID, this.state.startDate, this.state.endDate)
  }

  handleInputChange = (event) => {
    const stateKey = event.target.name
    this.setState({ [stateKey]: event.target.value }, this.validateStatementDate)
  }

  validateStatementDate() {
    const currentStartDate = this.state?.startDate;
    const currentEndDate = this.state?.endDate;
    if((moment(currentStartDate).year() || moment(currentEndDate).year()) < 1970){
      this.setState({isValidDate: false, validationErrorMsg: 'Start date or End date can not be less than 1970'});
    } else if(!moment(currentEndDate).isSameOrAfter(moment(currentStartDate))){
      this.setState({isValidDate: false, validationErrorMsg: 'Start date can not be greater than End date'});
    } else if(moment(currentEndDate).isSameOrAfter(moment(currentStartDate))){
      this.setState({isValidDate: true, validationErrorMsg:''});
      this.props.refresh()
    }
  }

  getFileName = (extension) => {
    return `CardStatementTrackingNumber_${this.props.cardDetails.TRACKINGNUMBER}_from${this.state.startDate}_to${this.state.endDate}.${extension}`
  }

  downloadExcelData = () => {
    const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    const binaryExcelData = b64toBlob(this.props.excelBase64Data)
    download(binaryExcelData, this.getFileName('xlsx'), mimeType)
  }

  createCsvString = () => {
    let csvString = ""
    if (this.props.transactions.length > 0) {
      const headers = this.props.exportColumns.map( item => item.LABEL)
      csvString += headers.join(",") + "\r\n"

      this.props.transactions.forEach( transaction => {
        const lineElements = this.props.exportColumns.map( column =>  transaction[column.VALUE].toString().split(',').join(''))
        csvString += lineElements.join(",") + "\r\n"
      })
      csvString = "data:application/csv," + encodeURIComponent(csvString)
      return csvString
    }
  }

  handleReverseRequest = (transaction) => {
    this.setState({
      reverseDialogOpen: true,
      transactionToReverse: transaction
    })
  }

  showChargebackInfo = (authorisationId) => {
    this.props.getSettlementChargebacks(authorisationId)
  }

  handleCloseChargebacks = () => {
    this.props.clearSettlementChargebacks()
  }

  handleReverseClose = (refresh) => {
    this.setState({
      reverseDialogOpen: false,
      transactionToReverse: null
    })
    this.props.resetReverseTransaction()

    if (refresh){
      this.props.refresh()
    }
  }

  handlePrintPdf = async () => {
    const doc = (
      <TransactionTablePrintDetails
        transactions={this.props.transactions}
        columns={this.props.visibleColumns}
        cardInfo={this.props.cardDetails}
      />
    );
    const asPdf = pdf([]);
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url);
    if (printWindow) {
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
      };
    }
  }

  render(){
    return(
    <Card style={{margin: '2px', marginTop: '4px', padding: '40px'}}>
      <CardHeader title="Transaction Statement" action={this.props.failedTransaction}/>
      <CardContent>
        <Grid
          justify="space-between"
          container
        >
          <Grid item>
            <Typography gutterBottom variant="h5">
              <DateFromDateTo
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onChangeStartDate={this.handleInputChange}
                onChangeEndDate={this.handleInputChange}
              />
            </Typography>
            { !this.state.isValidDate && <span style={{color:'red', font:'10px !important'}}>{this.state.validationErrorMsg}</span> }
          </Grid>
          <Grid item>
            {
              this.props.cardDetails && this.props.transactions.length > 0 && (
                <>
                  <PDFDownloadLink
                    document={
                      <TransactionTablePrintDetails
                        transactions={this.props.transactions}
                        columns={this.props.visibleColumns}
                        cardInfo={this.props.cardDetails}
                      />
                    }
                    fileName={this.getFileName('pdf')}
                    style={{ textDecoration: 'none' }}
                  >
                    {({ loading }) => (
                      <IconButton style={{ verticalAlign: 'middle', cursor: 'pointer' }}>
                        <Tooltip title="PDF">
                          <Icon color="primary">picture_as_pdf</Icon>
                        </Tooltip>
                      </IconButton>
                    )}
                  </PDFDownloadLink>
                  <IconButton style={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={this.handlePrintPdf}>
                    <Tooltip title="Print PDF">
                      <Icon color="primary">print</Icon>
                    </Tooltip>
                  </IconButton>
                </>
              )
            }
            {
              ( this.props.cardDetails &&  this.props.transactions.length > 0 ) &&
              <IconButton style={{verticalAlign: 'middle', cursor: 'pointer'}} onClick={this.downloadExcelData}>
                <Tooltip title="Excel"><Icon color="primary">receipt</Icon></Tooltip>
              </IconButton>
            }
            {
              ( this.props.cardDetails &&  this.props.transactions.length > 0 ) &&
               <a href={this.createCsvString()} download={this.getFileName('csv')}>
                <Tooltip title="CSV">
                  <Icon style={{verticalAlign: 'middle', cursor: 'pointer'}} color="primary">cloud_download</Icon>
                </Tooltip>
              </a>
            }
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        <TransactionTable transactions={this.props.transactions} columns={this.props.visibleColumns} reverse={this.handleReverseRequest} showChargebackInfo={this.showChargebackInfo} />
      </CardContent>
      <ReverseTransactionForm open={this.state.reverseDialogOpen} close={this.handleReverseClose} cardNumber={this.props.cardDetails.CARDNUMBER} transaction={this.state.transactionToReverse} />

      <SettlementChargebacksResults isOpen={this.props.chargebacks && this.props.chargebacks.length > 0}
                                    close={this.handleCloseChargebacks} chargebacks={this.props.chargebacks}/>

    </Card>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    cardDetailsResponse: state.cardDetails.cardDetailsResponse,
    transactions: state.cardDetails.transactions,
    visibleColumns: state.cardDetails.visibleColumns,
    exportColumns: state.cardDetails.exportColumns,
    columns: state.cardDetails.columns,
    excelBase64Data: state.cardDetails.excelBase64Data,
    chargebacks: state.cardDetails.chargebackInfo
  }
}

const mapDispatchToProps = {
  cardStatement, resetReverseTransaction, getSettlementChargebacks, clearSettlementChargebacks
}

CardTransactions.propTypes = {
  token: PropTypes.string.isRequired,
  cardDetailsResponse: PropTypes.any,
  cardDetails: PropTypes.object,
  cardID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  transactions: PropTypes.array.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  exportColumns: PropTypes.array.isRequired,
  excelBase64Data: PropTypes.any,
  chargebacks: PropTypes.array,
  cardStatement: PropTypes.func.isRequired,
  resetReverseTransaction: PropTypes.func.isRequired,
  getSettlementChargebacks: PropTypes.func.isRequired,
  clearSettlementChargebacks: PropTypes.func.isRequired,
  refresh: PropTypes.func,
  failedTransaction: PropTypes.node
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(CardTransactions))
